import L from "leaflet"
import { MapConfig } from "./map_config.js";
import { LocationHandler } from "./location_handler.js";

export class MapFactory {
  static createMainMap(container, center, options = {}) {
    const defaultOptions = {
      scrollWheelZoom: options.wheelZoom !== 'false'
    };

    const map = L.map(container, defaultOptions).setView(center, 14);    
    // Add tile layer based on layerType option    
    const tileConfig = options.layerType == 'thunderforest' ? MapConfig.getTileLayerOptions() : MapConfig.getOSMTileLayerOptions(); 
    L.tileLayer(tileConfig.url, tileConfig.options).addTo(map);

    // Add scale control
    L.control.scale().addTo(map);

    // Setup location control
    const locationHandler = new LocationHandler(map);
    locationHandler.setupLocationControl();

    return map;
  }

  static createPreviewMap(container, center) {
    const map = L.map(container, { scrollWheelZoom: false }).setView(center, 14);
    
    // Add OSM tile layer for preview
    const osmConfig = MapConfig.getOSMTileLayerOptions();
    L.tileLayer(osmConfig.url, osmConfig.options).addTo(map);

    // Add scale control
    L.control.scale().addTo(map);

    return map;
  }
}
